import { useContext } from 'react'

import { type SanityCollectionGridModule } from '@data/sanity/queries/types/modules'
import { StringsContext } from '@lib/strings-context'

import Button, { ButtonVariant } from '@components/buttons/button'
import ComplexPortableText from '@components/complex-portable-text'

type CollectionFooterProps = Pick<SanityCollectionGridModule, 'title'> & {
  isFilterActive: boolean
  processedProductCount: number
  hasPagination: boolean
  clearFilters: () => void
  loadMore: () => void
}

const CollectionFooter = ({
  title,
  isFilterActive,
  processedProductCount,
  hasPagination,
  clearFilters,
  loadMore,
}: CollectionFooterProps) => {
  const strings = useContext(StringsContext)

  return (
    <div className="container">
      {processedProductCount === 0 && (
        <div className="space-y-3 py-16 text-center">
          <ComplexPortableText content={strings.collectionFilterNoResults} />

          {isFilterActive && (
            <Button
              variant={ButtonVariant.LINK}
              onClick={clearFilters}
              className="uppercase"
            >
              {strings.collectionClearFiltersLabel}
            </Button>
          )}
        </div>
      )}

      {hasPagination && (
        <div className="py-12 flex flex-col items-center">
          <Button
            variant={ButtonVariant.FILLED}
            onClick={loadMore}
            className="w-full max-w-md"
          >
            {strings.buttonLoadMore}
            <span className="sr-only">
              {strings.collectionProducts?.replace(
                /{title}/gi,
                title ? `&quot;${title}&quot;` : '',
              )}
            </span>
          </Button>
        </div>
      )}
    </div>
  )
}

export default CollectionFooter
